import type { AppointmentType } from '@/features/appointments/utils/AppointmentType';

export const SF_APPOINTMENT_TYPE: Record<
  AppointmentType,
  'Phone' | 'In Person'
> = {
  online: 'Phone',
  'in-branch': 'In Person',
};
